import { useState, useEffect } from "react";
import { updateProfile } from "../../services/AuthService";
import Button from "../CommonComponents/Button";
import Headline from "../MainComponents/Headline";
import { Card, Label, Input, Message } from "../CommonComponents/DataCard"
import UserService from "../../services/UserService";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../../services/AuthService"
import { ROLES } from "../../services/Constants";

const STATUS_LABELS = {
    ACTIVE: "Aktivan",
    INACTIVE: "Neaktivan",
    STUDENT: "Student",
    RETIRED: "Umirovljenik",
};

const STATUS_OPTIONS = [
    { value: "ACTIVE", label: "Aktivan" },
    { value: "INACTIVE", label: "Neaktivan" },
    { value: "STUDENT", label: "Student" },
    { value: "RETIRED", label: "Umirovljenik" },
];

function ProfileModal({ username, onClose }) {
    const [profile, setProfile] = useState(null);
    const [editData, setEditData] = useState({});
    const [editing, setEditing] = useState(false);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);

    const navigate = useNavigate();
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const current = await getCurrentUser();
                if (current.authenticated === true) {
                    setCurrentUser(current);
                }
                const response = await UserService.getUserDetails(username);
                setProfile(response.user);
                setEditData(response.user);
            } catch (err) {
                setError(true);
                setMessage("Greška kod dohvaćanja profila");
            }
        };
        fetchData();
    }, [username]);

    const handleChange = (e) => {
        setMessage(null);
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        setError(null);
        try {
            editData.username = username
            const res = await updateProfile(editData);
            setProfile(editData);
            setEditing(false);
            setMessage(res.message);
        } catch (err) {
            setError(true);
            setMessage(err.message);
        }
    };

    const handleCancel = () => {
        setEditData(profile);
        setEditing(false);
        setError(null);
        setMessage(null);
    };

    if (!profile) return <p>Učitavanje profila...</p>;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    maxHeight: "100%",
                    overflowY: "auto",
                }}
            >
                <Card>
                    <div style={{ padding: "2rem" }}>
                        <Headline size="2rem" center>Profil korisnika</Headline>

                        {!editing ? (
                            <div style={{ display: "flex", flexDirection: "column", }}>
                                <p><strong>Korisničko ime:</strong> {profile.username}</p>
                                <p><strong>Ime:</strong> {profile.name}</p>
                                <p><strong>Prezime:</strong> {profile.surname}</p>
                                <p><strong>OIB:</strong> {profile.oib}</p>
                                <p><strong>Adresa:</strong> {profile.address}</p>
                                <p><strong>Email:</strong> {profile.email}</p>
                                <p><strong>Telefon:</strong> {profile.telephone || "-"}</p>
                                {profile.status && (
                                    <p><strong>Status:</strong> {STATUS_LABELS[profile.status] || profile.status}</p>
                                )}

                                <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
                                    <Button tekst="Uredi podatke" akcija={() => setEditing(true)} />
                                    <Button tekst="Zatvori" akcija={onClose} />
                                    <Button
                                        tekst="Povijest posudbi"
                                        akcija={() => {
                                            if (!profile?.id || !currentUser?.role) return;
                                            navigate("/povijest", { state: { userId: profile.id, role: currentUser.role } });
                                        }}
                                        disabled={!profile?.id || !currentUser?.role}
                                    />

                                </div>
                            </div>
                        ) : (
                            <form
                                style={{ display: "flex", flexDirection: "column", }}
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSave();
                                }}
                            >
                                <Label>OIB</Label>
                                <Input
                                    name="oib"
                                    value={editData.oib || ""}
                                    onChange={handleChange}
                                />

                                <Label>Ime</Label>
                                <Input
                                    name="name"
                                    value={editData.name || ""}
                                    onChange={handleChange}
                                />

                                <Label>Prezime</Label>
                                <Input
                                    name="surname"
                                    value={editData.surname || ""}
                                    onChange={handleChange}
                                />

                                <Label>Email</Label>
                                <Input
                                    name="email"
                                    value={editData.email || ""}
                                    onChange={handleChange}
                                />

                                <Label>Adresa</Label>
                                <Input
                                    name="address"
                                    value={editData.address || ""}
                                    onChange={handleChange}
                                />

                                <Label>Telefon</Label>
                                <Input
                                    name="telephone"
                                    value={editData.telephone || ""}
                                    onChange={handleChange}
                                />
                                {(currentUser?.role === ROLES.ADMIN || currentUser?.role === ROLES.EMPLOYEE) && (
                                    <>
                                        <Label>Status</Label>
                                        <select
                                            name="status"
                                            value={editData.status || "ACTIVE"}
                                            onChange={handleChange}
                                            style={{ width: "100%", padding: "0.5rem", marginBottom: "1rem", fontSize: "1rem", borderRadius: "4px", border: "1px solid #ccc" }}
                                        >
                                            {STATUS_OPTIONS.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    </>
                                )}
                                {message && <Message $success={!error}>{message}</Message>}
                                <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
                                    <Button type="submit" tekst="Spremi promjene" />
                                    <Button type="button" tekst="Odustani" akcija={handleCancel} />
                                </div>
                            </form>
                        )}
                    </div>
                </Card>
            </div>
        </div>
    );
}

export default ProfileModal;
